/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type api_updateAlumniSurveyInterestDecisionRequest = {
    decision?: api_updateAlumniSurveyInterestDecisionRequest.decision;
    interest_id: number;
};
export namespace api_updateAlumniSurveyInterestDecisionRequest {
    export enum decision {
        ACCEPTED = 'accepted',
        REJECTED = 'rejected',
    }
}

